var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useEffect, useRef, useState } from "react";
import { Box, styled, TextField, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { ApplicationContext } from "../ApplicationProvider";
import { ConfigitContext } from "../ConfigitProvider";
import { insertUserSavedSearch } from "../../services/UserSavedSearchService";
import { Order_By } from "../../models/GQLGeneratedModels";
import { genrateUuidv4 } from "../../services/ScenarioService";
import { ButtonComponent } from "../shared/ButtonComponent/ButtonComponent";
import { SnackbarComponent } from "../shared/SnackbarComponent";
import { Dialog } from "../shared/DialogComponent/Dialog";
import { ErrorModalComponent } from "../shared/ErrorModalComponent/ErrorModalComponent";
import { trimString } from "../SavedItems/AddNewRoofArea";
import { getConfigitCriteria } from "../../services/AssemblySearchAPIService";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var StyledTextField = styled(TextField)({ '&.MuiTextField-root': { background: 'white', width: '100%' }, '& .MuiInputBase-multiline': { padding: '0px' } });
export var SaveSearch = function () {
    var _a = useState(''), savedName = _a[0], setSavedName = _a[1];
    var azureADPCA = useMsal().instance;
    var _b = useContext(ApplicationContext), itemOffset = _b.itemOffset, itemsPerPage = _b.itemsPerPage, filters = _b.filters, setDialog = _b.setDialog, setShowDialog = _b.setShowDialog;
    var _c = useContext(ConfigitContext), layers = _c.layers, variableAssignments = _c.variableAssignments, manufacturerProduct = _c.manufacturerProduct, excludedLayerIds = _c.excludedLayerIds;
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var errorCheck = useRef(false);
    var _e = useState(false), apiErrorCheck = _e[0], setApiErrorCheck = _e[1];
    useEffect(function () { if (apiErrorCheck) {
        setDialog(/*#__PURE__*/ _jsx(Dialog, { label: "An Error Occurred", children: /*#__PURE__*/ _jsx(ErrorModalComponent, { message: "This search was not saved. Please Try again." }) }));
        setShowDialog(true);
    } }, [apiErrorCheck]);
    var getUserEmail = function () {
        var _azureADPCA$getActive, _azureADPCA$getActive2;
        var userEmail = ((_azureADPCA$getActive = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive === void 0 ? void 0 : _azureADPCA$getActive.username) || 'test@test.com'; // works for initial Azure B2C before customization
        // For customized Azure B2C, user email needs to be retrieved as follows:
        var tokenClaims;
        if ((_azureADPCA$getActive2 = azureADPCA.getActiveAccount()) !== null && _azureADPCA$getActive2 !== void 0 && _azureADPCA$getActive2.idTokenClaims) {
            var _azureADPCA$getActive3;
            tokenClaims = (_azureADPCA$getActive3 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive3 === void 0 ? void 0 : _azureADPCA$getActive3.idTokenClaims;
            if (tokenClaims && tokenClaims.hasOwnProperty('email')) {
                userEmail = tokenClaims['email'];
            }
        }
        return userEmail;
    };
    var saveSearch = function (e) { return __awaiter(void 0, void 0, void 0, function () { var _azureADPCA$getActive4, userGuid, userEmail, userSavedSearchCriteriaData, stringifiedData, userSavedSearchCriteria, savedSearchResult; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                e.preventDefault();
                errorCheck.current = false;
                if (savedName.trim().length === 0 || savedName === '')
                    errorCheck.current = true;
                if (!(errorCheck.current === false)) return [3 /*break*/, 2];
                userGuid = (_azureADPCA$getActive4 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive4 === void 0 ? void 0 : _azureADPCA$getActive4.localAccountId;
                userEmail = getUserEmail();
                userSavedSearchCriteriaData = getConfigitCriteria(layers, variableAssignments, excludedLayerIds, manufacturerProduct, itemsPerPage, itemOffset, { AssemblyId: Order_By.Asc, CoverSubassemblyId: Order_By.Asc, DeckSubassemblyId: Order_By.Asc });
                stringifiedData = JSON.stringify(userSavedSearchCriteriaData);
                userSavedSearchCriteria = { AzureB2CUserEmail: userEmail, AzureB2CUserGuid: userGuid, SearchCriteriaData: btoa(stringifiedData), Title: trimString(savedName, 255), UserSavedSearchGuid: genrateUuidv4() };
                return [4 /*yield*/, insertUserSavedSearch(userSavedSearchCriteria)];
            case 1:
                savedSearchResult = _a.sent();
                if (savedSearchResult) {
                    setApiErrorCheck(false);
                    if (savedSearchResult) {
                        setOpen(true);
                        setTimeout(function () { setShowDialog(false); }, 1500);
                    }
                }
                else {
                    if (savedSearchResult) {
                        setApiErrorCheck(true);
                    }
                }
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    }); }); };
    var handleClose = function (event, reason) { if (event) {
        setOpen(false);
        return;
    } };
    return /*#__PURE__*/ _jsxs(Box, { gap: 2, display: "flex", flexDirection: "column", children: [/*#__PURE__*/ _jsx(Typography, { className: 'py-2', fontFamily: 'Inter', fontSize: '16px', lineHeight: '20px', children: "Save search criteria to your account." }), /*#__PURE__*/ _jsxs("div", { className: "my-3", children: [/*#__PURE__*/ _jsxs(Typography, { className: 'small-para-semibold ', children: ["Save As:", /*#__PURE__*/ _jsx("span", { className: "roofnav-error", children: "*" })] }), /*#__PURE__*/ _jsx(StyledTextField, { value: savedName, onChange: function (e) { return setSavedName(e.target.value); }, id: "address2Input", placeholder: "", size: "small", inputProps: { maxLength: 255 } }), errorCheck.current === true && savedName.trim().length === 0 && /*#__PURE__*/ _jsx(Typography, { className: 'small-para roofnav-error pt-1', children: "Please enter a name for your search." })] }), /*#__PURE__*/ _jsx(ButtonComponent, { buttonType: "primary", buttonText: "Save", click: saveSearch }), /*#__PURE__*/ _jsx(SnackbarComponent, { open: open, handleClose: handleClose, message: 'Project successfully saved' })] });
};
